<template>
  <v-textarea
    :rules="rules"
    no-resize
    name="message"
    label="Mensagem"
    solo
  ></v-textarea>
</template>

<script>
import { requiredValidation } from "../validations/requiredValidation";
import { mixin } from "./mixin";

export default {
  data: () => ({
    rules: [requiredValidation("Digite a mensagem.")],
  }),
  mixins: [mixin],
};
</script>
